import { ref } from 'vue';
export type itemHeaderListItem = {
  attrName: string;
  showDelIcon: boolean;
}

let itemSkuHeaderList = ref<itemHeaderListItem[]>([]);

export const useAddItemSku = () => {
  return { itemSkuHeaderList };
};
